import React, { Component } from 'react';
import { Modal, Spin, Button, Icon } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import format from '../../shared/format';

const CONSTANTS = {
    title: '查看客户修改意见',
    noDataText: '暂无数据',
};

function TableTemplate({ data }) {
    return (
        <table className="quotation_table">
            <tbody>
                {
                    (data || []).map((item, index) => (
                        <tr key={index}>
                            <td className="quotation_td_left bg">{item.label}</td>
                            <td className="quotation_td_right">{item.value}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}

class CustomOpinion extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        // const { record: { jdeMainApplyId } } = this.state;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.queryJdeMainApplyApprovalHistory, {
        //     jdeMainApplyId,
        // }).then(res => {
        //     this.setState({
        //         data: res.data,
        //         loading: false,
        //     }, () => {
        //         this.loadData();
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ data: [
            { version: 'V3', guidePrice: '1600000', totalPrice: '1700000', opinion: '付款计划这边，第1笔付款希望可以调整至10%', attachment: 'JSYQ20190220001-V1-客户意见2.docx'},
            { version: 'V3', guidePrice: '1600000', totalPrice: '1700000', opinion: '付款计划这边，第1笔付款希望可以调整至10%', attachment: 'JSYQ20190220001-V1-客户意见2.docx'}
        ] });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    getTable = (data) => {
        const { version, guidePrice, totalPrice, opinion, attachment, fileMetaId } = data;
        return (
            <TableTemplate
                data={[
                    { label: '报价单版本', value: version },
                    { label: '报价单指导价', value: `${ format('money', guidePrice) } 元` },
                    { label: '报价单总价', value: `${ format('money', totalPrice) } 元` },
                    { label: '客户修改意见', value: opinion },
                    { label: '附件', value: <a onClick={() => this.downLoadFile(fileMetaId)}>{attachment}</a> },
                ]}
            />
        );
    }

    getContent = () => {
        const { data } = this.state;
        return (data || []).map((item, index) =>
            <div key={index} style={{ marginBottom: 16}}>
                {this.getTable(item)}
            </div>
        );
    }

    render() {
        const { visible, loading, data, record } = this.state;
        const { quotationNum, salesforceId } = record;
        return (
            <Modal
                title={CONSTANTS.title}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="640px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                {
                    (data || []).length ?
                        <div>
                            <div style={{ marginBottom: 16 }}>
                                报价单：{quotationNum}
                                <span className="ant-divider" />
                                Salesforce ID：{salesforceId}
                            </div>
                            <Spin spinning={loading}>
                                <div style={{ maxHeight: 430, overflowY: 'auto' }}>
                                    {this.getContent()}
                                </div>
                            </Spin>
                        </div>
                    :
                        <div style={{ marginTop: 100, marginBottom: 100, textAlign: 'center' }}>
                            <Icon type="frown-o" style={{ marginRight: 4, fontSize: '16px', color: '#999' }} />
                            {CONSTANTS.noDataText}
                        </div>
                }
            </Modal>
        );
    }
}

export default CustomOpinion;


// WEBPACK FOOTER //
// ./src/components/quotation/Components/CustomOpinion.js